var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"image",class:[
    _vm.shape,
    {
      cover: _vm.coverImg && _vm.src,
      placeholder: !_vm.src && !_vm.withoutPadding,
    } ],attrs:{"src":_vm.imageSrc,"alt":_vm.alt},on:{"load":function($event){return _vm.$emit('load')},"error":function($event){return _vm.$emit('error')}}})}
var staticRenderFns = []

export { render, staticRenderFns }